import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { fetchClientPreQuestionTableAndFilterSchema } from "model/ClientPreQuestionModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const ClientPreQuestionContext = createContext();

export const ClientPreQuestionProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [clientPreQuestionContextData, setClientPreQuestionContextData] = useState();

  const fetchClientPreQuestionContextData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchMetadataSchema("metadata:clientPreQuestion", () =>
        fetchClientPreQuestionTableAndFilterSchema([])
      );
      if (response?.success) {
        setClientPreQuestionContextData(response?.data);
      } else {
        setError(response?.message || "Unable to fetch client pre question metadata");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ClientPreQuestionContext.Provider
      value={{
        fetchClientPreQuestionContextData,
        clientPreQuestionContextData,
        loading,
        error,
      }}
    >
      {children}
    </ClientPreQuestionContext.Provider>
  );
};

export const useClientPreQuestionContext = () => useContext(ClientPreQuestionContext);
